import Reflux from 'reflux';

const actions = Reflux.createActions({
  setGanttRecords: { sync: true },
});

export default actions;
